/**
 * Mirror of the Notify backend `RoleEnum` (`Notify_Admin/Shared/Enums/RoleEnum.cs`).
 * Notify only has two roles. The string forms produced by reverse-indexing
 * (`UserRoleEnum[UserRoleEnum.SuperUser]` → `"SuperUser"`) are the canonical
 * role names persisted in `localStorage.userRole` and compared throughout
 * the app — matching the `Notify_Angular_Reference` AuthService convention.
 */
export enum UserRoleEnum {
  SuperUser = 1,
  Maintenance = 2,
}

export interface AuthModel {
  token: string;
  Response: { token: string; [key: string]: unknown };
  refreshToken: string;
  expiresIn: Date;
}

export interface UserModel extends AuthModel {
  id: number;
  username: string;
  email: string;
  fullname: string;
  roles: number[];
}

export type LoginParams = Record<string, never>;
